import PropTypes from 'prop-types'
import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'

import ErrorModal from '../application/ErrorModal'
import { ROOT_URL } from '../../constants/application'

import redoImage from '../../assets/images/redo.png'
import separatorImage from '../../assets/images/separator.png'
import shareImage from '../../assets/images/share.png'

const shareOnFacebook = href => (
  global.FB.ui(
    {
      method: 'share',
      href,
    }, () => { })
)

class HomeResult extends Component {
  constructor(props) {
    super(props)

    this.onMailingOptOutClick = this.onMailingOptOutClick.bind(this)

    const registration = ['id', 'birthday', 'city', 'email', 'gender', 'name'].reduce((result, key) => ({
      ...result,
      [key]: this.props.registration[key],
    }), {})

    this.state = {
      ...registration,
      message: '',
    }
  }

  componentDidMount() {
    if (!this.props.registrationOk) {
      this.props.history.push('/')
    }
  }

  onMailingOptOutClick() {
    global.firebase.firestore().collection('registrations')
      .doc(this.state.id)
      .update({
        mailing: false,
      })
      .then(() => {
        this.setState({
          message: 'Olá! Seu e-mail foi descadastrado da base.',
        })
        this.modal.show()
      })
  }

  renderResultFooter(callTitle, callURL) {
    return (
      <div>
        <p className="discret">
          A partir de agora, você vai receber e-mails da RPC.
          Caso não queira, <a href="#opt-out" onClick={this.onMailingOptOutClick}>clique aqui</a>.
        </p>

        <div className="btn-chamada-site">
          <a href={callURL} target="_blank" rel="noopener noreferrer">
            <button>{callTitle}</button>
          </a>
        </div>

        <div className="buttons">
          <button onClick={() => shareOnFacebook(ROOT_URL)}>
            Compartilhe <img src={shareImage} alt="Compartilhar" />
          </button>

          <a href={ROOT_URL}>
            <button>refazer <img src={redoImage} alt="Refazer" /></button>
          </a>
        </div>

        <p className="area-text">
          Fonte: INCA
        </p>
      </div>
    )
  }

  renderResultFemaleAboveForty() {
    return (
      <div>
        <div className="description">
          Você vai viver muito. Pra isso, precisa se cuidar.
          <br />
          <b>Já fez a mamografia este ano?</b>
        </div>
        <div className="conteudo-resposta">
          <p className="area-text">
            O câncer de mama é o câncer que mais mata mulheres no mundo. Mas ele tem
            prevenção.
            <br />
            Para garantir uma vida longa e feliz, faça a mamografia anualmente,
            pratique exercícios físicos, alimente-se de forma saudável, mantenha o
            peso corporal adequado e evite o consumo de álcool.
          </p>

          <p className="area-text">
            Outra dica de ouro é fazer o autoexame todos os meses.
          </p>

          {this.renderResultFooter('APRENDA A FAZER O AUTOEXAME', 'http://www.rpc.com.br/outubro-rosa/como-fazer-o-autoexame/')}
        </div>
      </div>
    )
  }

  renderResultFemaleBelowForty() {
    return (
      <div>
        <div className="description">
          Você vai viver muito. Pra isso, precisa se cuidar.
        </div>
        <div className="conteudo-resposta">
          <p className="area-text">
            <b>
              O câncer de mama é o câncer que mais mata mulheres no mundo. Mas ele
              tem prevenção.
            </b>
          </p>

          <p className="area-text">
            Para garantir uma vida longa e feliz, pratique exercícios físicos,
            alimente-se de forma saudável, mantenha o peso corporal adequado e evite
            o consumo de álcool.
          </p>

          <p className="area-text">
            Outra dica de ouro é fazer o autoexame todos os meses.
          </p>

          {this.renderResultFooter('APRENDA A FAZER O AUTOEXAME', 'http://www.rpc.com.br/outubro-rosa/como-fazer-o-autoexame/')}
        </div>
      </div>
    )
  }

  renderResultMale() {
    return (
      <div>
        <div className="description">
          Você vai viver muito. Pra isso, precisa se cuidar.
        </div>
        <div className="conteudo-resposta">
          <p className="area-text">
            Sabia que <b>homem também pode ter câncer de mama</b>? É raro
            (corresponde a apenas 1% de todos os casos registrados, de acordo com o
            INCA), mas pode acontecer. Por isso, cuide-se.
          </p>

          <p className="area-text">
            <b>O seu futuro está nas suas mãos!</b>
          </p>

          <p className="area-text">
            Aproveitando, dê um toque na mãe, na irmã e na esposa! É importante que
            elas façam o autoexame mensalmente. Após os 40 anos, elas ainda devem
            fazer a mamografia anualmente.
          </p>

          {this.renderResultFooter('MAIS INFORMAÇÕES', 'http://www.rpc.com.br/outubro-rosa/')}
        </div>
      </div>
    )
  }

  renderResult() {
    if (this.state.gender === 'male') {
      return this.renderResultMale()
    } else if (moment(this.state.birthday, 'DD/MM/YYYY').isBefore(moment().subtract(40, 'years'))) {
      return this.renderResultFemaleAboveForty()
    }

    return this.renderResultFemaleBelowForty()
  }

  render() {
    return (
      <div className="background page-resultado resultado-page">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="nome-usuario">{this.state.name}</div>

              <div className="div-usuario">
                <img src={separatorImage} alt="separator" />
              </div>
            </div>

            {this.renderResult()}
          </div>
        </div>

        <ErrorModal
          ref={(ref) => { this.modal = ref }}
          message={this.state.message}
        />
      </div>
    )
  }
}

HomeResult.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    birthday: PropTypes.string,
    city: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  registrationOk: PropTypes.bool.isRequired,
}

HomeResult.defaultProps = {
  history: {
    push: () => { },
  },
}

const mapStateToProps = state => ({
  registration: state.registration,
  registrationOk: !!state.registration['registration-ok'],
})

export default connect(mapStateToProps)(HomeResult)



// WEBPACK FOOTER //
// ./src/components/home/Result.js